import { render } from "./AlertModal.vue?vue&type=template&id=362bc15a&scoped=true&ts=true"
import script from "./AlertModal.vue?vue&type=script&lang=ts"
export * from "./AlertModal.vue?vue&type=script&lang=ts"

import "./AlertModal.vue?vue&type=style&index=0&id=362bc15a&lang=scss&scoped=true"

import exportComponent from "/srv/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-362bc15a"]])

export default __exports__